import React, { useEffect } from "react";
import { AlertTriangle, CheckCircle, XCircle } from "lucide-react";

const ErrorMessage = ({
  message,
  onClose,
}: {
  message: string;
  onClose: () => void;
}) => {
  if (!message) return null;
  if (typeof message !== "string") {
    console.error("ErrorMessage: message must be a string");
    return null;
  }
  if (message.length === 0) return null;
  if (message.length > 200) {
    console.warn(
      "ErrorMessage: message is too long, truncating to 200 characters",
    );
    message = message.substring(0, 200) + "...";
  }
  if (typeof onClose !== "function") {
    console.warn("ErrorMessage: onClose should be a function");
    return null;
  }
  useEffect(() => {
    const timer = setTimeout(onClose, 5000); // Auto close after 5 seconds
    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, [onClose]);
  return (
    <div
      className="fixed bottom-4 left-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 pr-4 rounded-md shadow-lg z-50000 flex items-center gap-2"
      role="alert"
    >
      <AlertTriangle className="text-red-300 w-6 h-6" />
      <span>
        <strong className="font-bold">Erro: </strong>
        {message}
      </span>

      <button onClick={onClose} className="ml-4 text-red-200 hover:text-white">
        <XCircle className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ErrorMessage;
